import * as bootstrap from "bootstrap"

window.addEventListener("DOMContentLoaded", () => {
  const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  tooltips.forEach((tooltip) => new bootstrap.Tooltip(tooltip))
})
